import { Icon } from '@iconify/react';

const Features = () => {
  const features = [
    {
      icon: 'mdi:account-search',
      title: 'Rekrutmen Terintegrasi',
      desc: 'Posting lowongan, screening otomatis dengan AI, dan kelola pipeline kandidat dalam satu dashboard.',
      color: 'bg-zentra-50',
      iconColor: 'text-zentra-600',
    },
    {
      icon: 'mdi:account-group',
      title: 'Manajemen Karyawan',
      desc: 'Database karyawan terpusat, tracking kehadiran, cuti, dan performa secara real-time.',
      color: 'bg-emerald-50',
      iconColor: 'text-emerald-600',
    },
    {
      icon: 'mdi:robot',
      title: 'AI Screening',
      desc: 'AI menganalisis CV dan jawaban kandidat secara otomatis, menghemat 80% waktu screening.',
      color: 'bg-amber-50',
      iconColor: 'text-amber-600',
    },
    {
      icon: 'mdi:cash-multiple',
      title: 'Payroll & Gaji',
      desc: 'Kalkulasi gaji otomatis termasuk BPJS, PPh21, tunjangan, dan lembur dengan akurasi 100%.',
      color: 'bg-rose-50',
      iconColor: 'text-rose-600',
    },
    {
      icon: 'mdi:chart-bar',
      title: 'Analytics & Laporan',
      desc: 'Dashboard interaktif dengan insight real-time untuk keputusan HR yang berbasis data.',
      color: 'bg-cyan-50',
      iconColor: 'text-cyan-600',
    },
    {
      icon: 'mdi:calendar-check',
      title: 'Absensi & Cuti',
      desc: 'Sistem absensi GPS-enabled, pengajuan cuti otomatis, dan approval berjenjang.',
      color: 'bg-indigo-50',
      iconColor: 'text-indigo-600',
    },
  ];

  return (
    <section id="fitur" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">

        {/* ===== HEADER ===== */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-zentra-50 rounded-full px-4 py-1.5 mb-4">
            <Icon icon="mdi:puzzle" className="text-zentra-500 text-sm" />
            <span className="text-xs font-medium text-zentra-600">Fitur Lengkap</span>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4 leading-tight">
            Platform HR Terlengkap untuk{' '}
            <br className="hidden sm:block" />
            Bangun Tim Hebat
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto leading-relaxed">
            Kelola seluruh siklus hidup karyawan dari rekrutmen hingga pensiun{' '}
            <br className="hidden sm:block" />
            dalam satu platform terintegrasi
          </p>
        </div>

        {/* ===== FEATURES GRID ===== */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="feature-card bg-white border border-gray-100 rounded-2xl p-7 transition-all duration-300 hover:border-zentra-200 hover:shadow-lg group"
            >
              <div className={`w-12 h-12 rounded-xl ${feature.color} flex items-center justify-center mb-5 group-hover:scale-110 transition-transform duration-300`}>
                <Icon icon={feature.icon} className={`text-2xl ${feature.iconColor}`} />
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{feature.desc}</p>
              <div className="mt-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <span className="text-xs font-medium text-zentra-600 inline-flex items-center gap-1">
                  Pelajari lebih lanjut
                  <Icon icon="mdi:arrow-right" className="text-sm" />
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* ===== BOTTOM CTA ===== */}
        <div className="mt-16 text-center">
          <p className="text-gray-500 mb-4">Masih ragu? Coba sendiri gratis selama 14 hari</p>
          <button className="gradient-btn text-white text-sm font-semibold px-8 py-3.5 rounded-xl hover:shadow-lg hover:shadow-zentra-500/25 transition-all">
            Mulai Gratis Sekarang
            <Icon icon="mdi:arrow-right" className="inline-block ml-2 text-sm" />
          </button>
        </div>

      </div>
    </section>
  );
};

export default Features;
